import { render, staticRenderFns } from "./EditManager.vue?vue&type=template&id=406dbaac&scoped=true"
import script from "./EditManager.vue?vue&type=script&lang=js"
export * from "./EditManager.vue?vue&type=script&lang=js"
import style0 from "./EditManager.vue?vue&type=style&index=0&id=406dbaac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "406dbaac",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VBtn,VCard,VTextField})
